import { createContext, Fragment, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { SpeechManager } from '@sas/direct-speech';
import cn from './DirectSpeech.css.json';
import './DirectSpeech.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DirectSpeechContext = /*#__PURE__*/createContext(undefined);

/**
 * This is used internally by AppRoot. Consumers should not need to use this in isolation.
 */
export const DirectSpeechProvider = props => {
  const [politeSpeechManager, setPoliteSpeechManager] = useState(undefined);
  const [assertiveSpeechManager, setAssertiveSpeechManager] = useState(undefined);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/createPortal( /*#__PURE__*/_jsxs("div", {
      className: cn.speechContainer,
      children: [/*#__PURE__*/_jsx("div", {
        ref: ref => {
          if (!assertiveSpeechManager && ref) {
            setAssertiveSpeechManager(new SpeechManager(ref));
          }
        },
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": true,
        "aria-relevant": "additions text"
      }), /*#__PURE__*/_jsx("div", {
        ref: ref => {
          if (!politeSpeechManager && ref) {
            setPoliteSpeechManager(new SpeechManager(ref));
          }
        },
        role: "status",
        "aria-live": "polite",
        "aria-atomic": true,
        "aria-relevant": "additions text"
      })]
    }), document.body), /*#__PURE__*/_jsx(DirectSpeechContext.Provider, {
      value: {
        politeSpeechManager,
        assertiveSpeechManager
      },
      children: props.children
    })]
  });
};
/**
 * Hook for using the DirectSpeechContext
 */
export function useDirectSpeech(props) {
  const mode = props?.mode ?? 'polite';
  // These speechManagers will be undefined until they are succesfully constructed
  // after we have our speech container div ref
  const {
    politeSpeechManager,
    assertiveSpeechManager
  } = useContext(DirectSpeechContext) ?? {};
  return mode === 'polite' ? politeSpeechManager : assertiveSpeechManager;
}
//# sourceMappingURL=DirectSpeechProvider.js.map